module.exports = __webpack_public_path__ + "static/img/servicesBanner2.fab105c7.png";